import React, { useEffect, useState } from 'react';
import Container from 'js/components/container/container';
import Layout from 'js/components/layout/layout';
import { sendAnalyticsEvent } from 'js/utils';
import analyticsEvents from 'js/enums/analytics-events.enum';
import LandingPage from './components/landing-page';
import PageHeader from './components/page-header';
import PageFooter from './components/page-footer';
import Wizard from './components/wizard';
import steps from './enums/steps.enum';

const QuickStart = ({
    form,
    integrations,
    topics,
    termsAndConditions,
    loading,
    submitting,
    validating,
    errors,
    scaleScore,
    scaleError,
    scaleChanging,
    onFormChange,
    onFormReset,
    onReload,
    onSubmit,
    onValidate,
    onGetScaleScore,
}) => {
    const [currentStep, setCurrentStep] = useState();
    const [targetStep, setTargetStep] = useState();
    const [showFooter, setShowFooter] = useState(false);

    useEffect(() => {
        if (targetStep && !loading && !errors.loading) {
            setCurrentStep(targetStep);
            setTargetStep(null);
        }
    }, [targetStep, loading, errors.loading]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(
        () => {
            if (currentStep === steps.SUMMARY && targetStep === steps.DETAILS) {
                onFormReset();
            }
        },
        [currentStep, targetStep], // eslint-disable-line react-hooks/exhaustive-deps
    );

    useEffect(() => {
        if (
            currentStep !== steps.BUILD_CONTEXT &&
            currentStep !== steps.CHOOSE_DSP &&
            currentStep !== steps.ACTIVATE
        ) {
            setShowFooter(false);
        } else if (form.topics.length || form.keywords.length) {
            setShowFooter(true);
        }
    }, [currentStep, form.topics.length, form.keywords.length]);

    useEffect(() => {
        sendAnalyticsEvent(analyticsEvents.QUICK_START.STEP_CHANGE, {
            step: currentStep || 'Landing Page',
        });
    }, [currentStep]);

    return (
        <Layout
            isFooterSticky
            header={currentStep && <PageHeader />}
            footer={
                showFooter && (
                    <PageFooter
                        form={form}
                        scaleScore={scaleScore}
                        scaleError={scaleError}
                        scaleChanging={scaleChanging}
                        onFormChange={onFormChange}
                        onGetScaleScore={onGetScaleScore}
                    />
                )
            }
        >
            {!currentStep ? (
                <LandingPage
                    loading={targetStep && loading}
                    loadingError={targetStep && errors.loading}
                    onStart={() => {
                        setTargetStep(steps.DETAILS);
                        if (errors.loading) {
                            onReload();
                        }
                    }}
                />
            ) : (
                <Container size="medium">
                    <Wizard
                        step={currentStep}
                        form={form}
                        integrations={integrations}
                        topics={topics}
                        termsAndConditions={termsAndConditions}
                        errors={errors}
                        scaleScore={scaleScore}
                        scaleError={scaleError}
                        submitting={submitting}
                        validating={validating}
                        onFormChange={onFormChange}
                        onStepChange={(step) => setTargetStep(step)}
                        onSubmit={onSubmit}
                        onValidate={onValidate}
                    />
                </Container>
            )}
        </Layout>
    );
};

export default QuickStart;
